import { useContext } from 'react'
import { AuthContext } from 'src/context/auth.context'
import { ApiResponse } from 'src/domain/api'
import { ProgressStatusEnum, UpdateStatuses } from 'src/slices/services/api'
import AuthenticatedApi from 'src/slices/services/authenticatedApi'
import { axiosErrorMessage } from 'src/slices/services/error'
import { clearGetTenantSalesReports } from 'src/slices/tenantSalesReports/tenantSalesReportsSlice'
import { useAppDispatch } from 'src/store'

export const useApiSalesDate = () => {
  const authContext = useContext(AuthContext)
  const dispatch = useAppDispatch()

  const updateStatus = async (
    orgCode: string,
    storeCode: string,
    salesDateIds: string[],
    progressStatus: ProgressStatusEnum
  ): Promise<ApiResponse<void>> => {
    try {
      const token = authContext.getAuthToken()
      if (!token) {
        return {
          success: false,
          message: 'ログインしなおしてください: token is not found',
        }
      }

      const updateStatuses: UpdateStatuses = {
        salesDateIds,
        progressStatus,
      }
      await new AuthenticatedApi(
        token
      ).patchOrganizationsOrganizationCodeStoresStoreCodeBulkUpdateSalesDateStatuses(
        orgCode,
        storeCode,
        updateStatuses
      )
      // 精査画面が変更前の reportStatus を使い回さないよう、詳細の保存分を捨てる
      dispatch(clearGetTenantSalesReports())
      return { success: true }
    } catch (e: unknown) {
      const message = axiosErrorMessage(e)
      return { success: false, message }
    }
  }

  return { updateStatus }
}
